import { i18n, stores, reaction, action, runInAction } from 'mutants-microfx';
import _cloneDeep from 'lodash/cloneDeep';
import RetailBaseController from './RetailBaseController';
import { computed, toJS } from 'mobx';
import { PosSetData, PosInitData, UserData } from 'tplus-poslogin';
import { Message ,printDispatch,DoNameList} from 'tplus-components-touch';
import tools from '../util/tools';
const user = stores.user;

import '../commom/Challenger';
import { InitDataProcessor } from '../domain/retail/InitDataProcessor';
/**新增存货改变相关处理 */
import { AddInventoryProcessorBlock } from '../domain/retail/AddInventoryProcessorBlock';
/**删除明细行处理 */
import { RowDeleteProcessorBlock } from '../domain/retail/RowDeleteProcessorBlock';
/**数量改变相关处理 */
import { QuantityChangeProcessorBlock } from '../domain/retail/quantity/QuantityChangeProcessorBlock';
/**数量2改变相关处理 */
import { Quantity2ChangeProcessorBlock } from '../domain/retail/quantity/Quantity2ChangeProcessorBlock';
/**零售价格改变相关处理 */
import { RetailPriceChangeProcessorBlock } from '../domain/retail/priceAmount/RetailPriceChangeProcessorBlock'
/**含税金额改变相关处理 */
import { TaxPriceChangeProcessorBlock } from '../domain/retail/priceAmount/TaxPriceChangeProcessorBlock';
/**含税金额相关处理 */
import { TaxAmountChangeProcessorBlock } from '../domain/retail/priceAmount/TaxAmountChangeProcessorBlock';
/**自由项相关处理 */
import { UpdateFreeItemsProcessorBlock } from '../domain/retail/freeItem/UpdateFreeItemsProcessorBlock';
/**单据日期相关处理 */
import { VoucherDateProcessor } from '../domain/retail/VoucherDateProcessor';
/**计量单位改变 */
import { UnitProcessorBlock } from '../domain/retail/UnitProcessorBlock';
/**零售打印 */
import { RetailPrintProcessBlock } from '../domain/retail/print/RetailPrintProcessBlock';
/**只打印小票 */
import { OnlyRetailPrintProcess } from '../domain/retail/print/OnlyRetailPrintProcess';
/**交班单打印 */
import { ShiftVoucherPrintProcessBlock } from '../domain/retail/print/ShiftVoucherPrintProcessBlock';
/**日班单打印 */
import { DailyVoucherPrintProcessBlock } from '../domain/retail/print/DailyVoucherPrintProcessBlock';
/**会员储值单打印 */
import { StoragePrintProcessBlock } from '../domain/retail/print/StoragePrintProcessBlock';
/**项目储值单打印 */
import { ProjectStoragePrintProcessBlock } from '../domain/retail/print/ProjectStoragePrintProcessBlock';
/**扣次打印 */
import { ProjectConsumePrintProcessBlock } from '../domain/retail/print/ProjectConsumePrintProcessBlock';
/**配送小票打印*/
import { MeiTuanPrintProcessBlock } from '../domain/retail/print/MeiTuanPrintProcessBlock';

/**校验最低售价 */
import { ControlMinPriceProcessorBlock } from '../domain/retail/validate/controlMinPrice/ControlMinPriceProcessorBlock'
/**库存查询的明细转换为零售单 */
import { ConvertRetailDetailFromStockProcessorBlock } from '../domain/retail/convertVoucher/ConvertRetailDetailFromStockProcessorBlock'
/**结算时校验 */
import { SettleValidateProcessorBlock } from '../domain/retail/SettleValidateProcessorBlock';
import { AuthorityValidateProcessorBlock } from '../domain/retail/AuthorityValidateProcessorBlock';

/**成交金额抹零 */
import { DealAmountSettingProcessorBlock } from '../domain/retail/priceAmount/AmountSetting/DealAmountSettingProcessorBlock';
/**单品金额抹零 */
import { DealSingleRowAmountSettingProcessorBlock } from '../domain/retail/priceAmount/AmountSetting/DealSingleRowAmountSettingProcessorBlock'

import { initLogController } from '../log/LogController';
import { ChangeMemberProcessorBlock } from '../domain/retail/member/ChangeMemberProcessorBlock'
/**抹零 */
import { WipeChangeProcessorBlock } from '../domain/retail/WipeChangeProcessorBlock'
/**单品打折 */
import { SingleDiscountOperationProcessorBlock } from '../domain/retail/detail/SingleDiscountOperationProcessorBlock';
/**贈品相关处理 */
import { SinglePresentProcessorBlock } from '../domain/retail/detail/SinglePresentProcessorBlock';
/**整单打折 */
import { WholeDiscountProcessorBlock } from '../domain/retail/WholeDiscountProcessorBlock';
/**整单赠送 */
import { WholePresentProcessorBlock } from '../domain/retail/WholePresentProcessorBlock';
/**改变生产日期计算失效日期 */
import { CalculateExpiryDateProcessor } from "../domain/retail/batch/CalculateExpiryDateProcessor";
/**改变失效日期计算生产日期 */
import { CalculateProductionDateProcessor } from '../domain/retail/batch/CalculateProductionDateProcessor';
import { SettlePromotionProcessBlock } from '../domain/retail/promotion/SettlePromotionProcessBlock'

import operationLog from '../domain/operationLog/OperationLog';

/**导购员相关处理 */
import { PersonProcessBlock } from '../domain/retail/person/PersonProcessBlock';

// import RetailApi from '../api/RetailApi';
import PromotionApi from '../api/PromotionApi';
/**钱箱相关处理 */
import { OpenCashBoxProcessBlock } from '../domain/retail/cashBox/OpenCashBoxProcessBlock';
//枚举
import { PromotionType, DataSource, SettleCode, busiTypeID, DistributionMode, PromotionObject } from '../commom/Enum';
/**数量2改变修改处理 */
import { Quantity2ToQuantityProcessor } from '../domain/retail/quantity/Quantity2ToQuantityProcessor';
/**数量改变相关处理 */
import { QuantityToQuantity2Processor } from '../domain/retail/quantity/QuantityToQuantity2Processor';
/**功能权限处理 */
import { AuthProcess } from '../domain/retail/auth/AuthProcess';
/**储值时校验 */
import { CheckMemberStorageProcessorBlock } from '../domain/retail/validate/controlMember/CheckMemberStorageProcessorBlock';
/**修改会员密码时校验 */
import { CheckUpdateMemberPasswordProcessorBlock } from '../domain/retail/validate/controlMember/CheckUpdateMemberPasswordProcessorBlock'
/**项目储值时校验 */
import { CheckMemberProjectStorageProcessorBlock } from '../domain/retail/validate/controlMember/CheckMemberProjectStorageProcessorBlock';


import { PreWholeFullSingleProcessBlock } from '../domain/retail/promotion/whole/PreWholeFullSingleProcessBlock'

/**统计相关信息 */
import { SelfRunPromotionProcessBlock } from '../domain/retail/promotion/SelfRunPromotionProcessBlock'

import { CalcMultGiftItemProcessBlock } from '../domain/retail/promotion/calcmeet/CalcMultGiftItemProcessBlock'

import { AddLogProcessor } from '../domain/operationLog/AddLogProcessor'

//原单退货
import { OriginalReturnProcessBlock } from '../domain/retail/originalReturn/OriginalReturnProcessBlock'
import { OriginalReturnPaymentProcessBlock } from '../domain/retail/originalReturn/OriginalReturnPaymentProcessBlock'
import { ReturnTaxAmountProcessBlock } from '../domain/retail/originalReturn/ReturnTaxAmountProcessBlock'
import { CheckCanWeighFromBarCodeBlock } from '../domain/retail/CheckCanWeighFromBarCodeBlock'

import { VoucherUiStateProcessor } from '../domain/view/VoucherUiStateProcessor'
import { OperationsUiStateProcessor } from '../domain/view/OperationsUiStateProcessor'

//次卡扣次校验
import { DeductionValidateProcessorBlock } from '../domain/retail/DeductionValidateProcessorBlock';

import { AccwhenScan } from '../commom/Enum'
export default class RetailOrderController extends RetailBaseController {

  //tuzha 行点击事件
  rowClick({ index }) {
    this.refundVoucherControl(index);
  }

  //原单退货的控制
  refundVoucherControl(index) {
    $T.debugger();
    //不是原单退货，直接返回，不控制
    if (!this.isOriginalReturn()) {
      return;
    }
    //明细行数据
    let refundDetail = this.getRefundDetail(index);
    const detailDto = this.data.RetailDetails[index];

    const voucherView = this.viewModel.items.find(el => el.name == "Voucher");
    VoucherUiStateProcessor.execute(detailDto, refundDetail, voucherView);
    //按钮控制数据
    const operationView = this.viewModel.items.find(el => el.name == "Operations");
    OperationsUiStateProcessor.execute(detailDto, refundDetail, operationView);
  }

  async initData() {
    console.log('initData开始执行');
    try {
      await InitDataProcessor.execute(this.data);
    } catch (error) {
      // 测试代码，发版时删除
      alert("初始化方法报错，请联系开发，报错信息：" + error);
    }
    const viewModelNames = ['Voucher', 'Operations'];

    try {
      viewModelNames.forEach((name) => {
        const viewModel = this.viewModel.items && this.viewModel.items.find(el => el.name == name);
        viewModel && viewModel.clearUiState();
      })
    } catch (error) {
      console.warn(error)
    }

    console.log('initData执行完成');

    // reaction(() => [this.data.Idmember], () => {
    //   alert('会员ID发生变化，请确认是否修改会员，如没有修改会员，请联系开发！');
    //   console.log(this.data.Idmember)
    // })
  }
  /**
   * 退货初始化
   */
  async initReturnInventory() {
    //datamodel 清空
    await this.init();

    runInAction(() => {
      //开单退货状态
      this.data.IdbusiType = 35;// datamodal改成退货状态
    });

  }
  async init() {
    super.init();
    // this.inputFeedbackModal('',111,333)
    await this.initData();
  }

  //会员修改
  async changeMember(member) {
    console.log('表头部分给变memberid', new Date().toLocaleString(), member)
    $T.debugger();
    //tuzh 原单退货不支持修改会员
    if (this.isOriginalReturn()) {

      let originalIdMember = this.refundRetail.Idmember;
      let newIdMember = null;
      if (member) {
        newIdMember = member.ID;
      }
      if (originalIdMember != newIdMember) {
        Message.warn("原单退货不支持修改会员");
        return;
      }

    }

    ChangeMemberProcessorBlock.execute(this.data, member);
  }

  // -------------------------------- 2.3.1.4.2.	录入商品 ----------------------------------
  /**
   *添加存货
   *
   * @param {*} RetailDetailUpdate
   * @param {*} retailDetail
   * @memberof RetailOrderController
   */
  async addInventory(RetailDetailUpdate, retailDetail) {
    $T.debugger();
    await runInAction(() => {
      const voucherVM = this.viewModel.getViewItem('Voucher');
      let desc = `添加明细行存货【${retailDetail.Inventory.Name}】数据`;
      AddLogProcessor.execute("添加存货", this.data.Code, desc);
      //tuzh 如果是原单退货，则添加商品为换货，则为正数
      if (this.isOriginalReturn()) {
        retailDetail.Quantity = -retailDetail.Quantity;
        QuantityChangeProcessorBlock.execute(this.data, retailDetail, retailDetail.Quantity, {});
      }
      AddInventoryProcessorBlock.execute(this.data,
        retailDetail,
        RetailDetailUpdate,
        voucherVM && voucherVM.targetIndex);
    });

    // //原单退货添加完存货后自动触发状态控制
    // if (this.isOriginalReturn()) {
    //   this.refundVoucherControl(this.data.RetailDetails.length - 1)
    // }

    $T.debugger();
  }

  //获取存货行
  getRowIndex(retailDetail) {
    const voucherVM = this.viewModel.getViewItem('Voucher');
    let targetIndex = voucherVM.targetIndex;
    let _this = this;
    const diff = (it, detail, index) => {
      let arr = ['Idinventory', 'Idunit', 'Batch', 'ExpiryDate', 'FreeItem0', 'FreeItem1', 'FreeItem2', 'FreeItem3', 'FreeItem4', 'FreeItem5', 'FreeItem6', 'FreeItem7', 'FreeItem8', 'FreeItem9'];
      for (let i = 0; i < arr.length; i++) {
        let status = false;
        let item = arr[i];
        switch (it[item] ? typeof it[item] : 'string') {
          case 'string': case 'number':
            if (it[item] != detail[item]) {
              status = true;
            }
            let accwhenScan = PosInitData("AccwhenScan");
            /**
             * 与上行相同才累加 -- "accwhenScan_01": "1222",
             * 累加 -- "accwhenScan_02": "1223",
             * 不累加 -- "accwhenScan_03": "1224",
             * */
            if (AccwhenScan.accwhenScan_02 != accwhenScan) {
              let data1 = _this.data.RetailDetails;
              if (data1 && data1.length > 1) {
                if (data1 && index === (targetIndex + 1)) {
                  return true;
                } else {
                  return false;
                }
              }
            } else {
              if (it.RetailPrice === detail.RetailPrice && it.Idinventory === detail.Idinventory) {
                return true;
              } else {
                return false;
              }
            }
            break;
          case 'object':
            if (isNaN(it[item]) && !isNaN(it[item])) {
              if (it[item] != detail[item]) {
                status = true;
              }
            } else {
              if (it[item]['Name'] != detail[item]['Name']) {
                status = true;
              }
            }
            break;
        }
        if (status == true) {
          return false;
        }
      }
      return true;
    }
    return this.data.RetailDetails.findIndex((it, index) => diff(it, retailDetail, index));
  }


  /**
   * 库存查询的明细转换到零售单
   */
  async ConvertRetailDetailFromStockProcessor(RetailDetailUpdate, retailDetail) {
    // 库存查询的明细转换到零售单
    await ConvertRetailDetailFromStockProcessorBlock.execute(this.data, retailDetail, RetailDetailUpdate)
  }

  /**
   * 抹零、整单金额都走这个业务逻辑
   * 根据抹零金额进行明细行的抹零金额进行分配
   */
  @operationLog('updateWipeChange', '抹零金额：{0}')
  async updateWipeChange(WipeChange) {
    await WipeChangeProcessorBlock.execute(this.data, WipeChange);
  }

  //修改单品打折
  @operationLog('updateSingleSale', '商品({0})折扣由{1}修改为{2}', ['1-Inventory.Name', '1-DiscountRate', '0'])
  async updateSingleSale(SingleSale, targetIndex) {
    SingleDiscountOperationProcessorBlock.execute(this.data, this.data.RetailDetails[targetIndex], SingleSale);
  }

  //整单打折
  @operationLog('updateTotalSale', '整单打折为:{0}')
  async updateTotalSale(DiscountRate) {
    console.log('编写整单打折逻辑');
    WholeDiscountProcessorBlock.execute(this.data, DiscountRate);
  }

  //赠品 单行明细标识为赠送
  @operationLog('updateSinglePresent', '第{0}行商品({1})标识为赠品', ['0', '0-Inventory.Name'])
  updateSinglePresent(targetIndex) {
    console.log('编写单行赠送逻辑');
    SinglePresentProcessorBlock.execute(this.data, this.data.RetailDetails[targetIndex]);
  }


  //整单赠送
  @operationLog('updateTotalPresent', '执行整单赠送')
  updateTotalPresent() {
    console.log('编写整单赠送逻辑');
    WholePresentProcessorBlock.execute(this.data);
  }

  //修改自由项
  @operationLog('updateFreeItem', '商品({0})自由项修改为{1}', ['1-Inventory.Name', '0'])
  async updateFreeItem(freeitem, targetIndex) {
    console.log('编写修改自由项逻辑:', freeitem);
    UpdateFreeItemsProcessorBlock.execute(this.data, this.data.RetailDetails[targetIndex], freeitem);
    console.log('编写修改自由项逻辑完成');
  }

  //修改批号
  //@operationLog('updateBatch', '商品({0})批次修改为{1}', ['1-Inventory.Name', '0'])
  async updateBatch(batchs, targetIndex) {
    console.log('编写修改自由项逻辑:', batchs);
    $T.debugger();
    if (!(batchs && batchs.length > 0)) {
      // 没有返回批号的场合
      return;
    }

    let retailDetail = this.data.RetailDetails[targetIndex];

    var RetailDetailUpdate = {};
    RetailDetailUpdate.Batchs = batchs;
    RetailDetailUpdate.event = "batch";
    await runInAction(() => {
      console.log('编写修改自由项逻辑runInAction');
      $T.debugger();
      const voucherVM = this.viewModel.getViewItem('Voucher');
      AddInventoryProcessorBlock.execute(this.data,
        retailDetail,
        RetailDetailUpdate,
        voucherVM && voucherVM.targetIndex);
    });
    let batchStr=  batchs.map(item=>{
      return item.Batch
  }).join(",");
    let desc = `商品(${retailDetail.Inventory.Name}),批次修改为【${batchStr}】`;
    AddLogProcessor.execute("修改批号", this.data.Code, desc);
  }

  /**
   * 修改批号明细上的数量
   * @param {*} param
   */
  @action
  async updateBatchDetail(param) {
    console.log("updateRetailDetail开始执行:", param);
    $T.debugger();
    // let batchsData = param.batchsData;
    // let index = param.index;
    let updateProp = param.updateProp;
    let updateRetailDetail = param.updateRetailDetail;
    let desc = '';
    $T.debugger();
    if ("Quantity" === updateProp.name) {
      updateRetailDetail.Quantity = updateProp.newData;
      desc = `修改存货【${updateRetailDetail.Inventory.Name}】数量为【${updateRetailDetail.Quantity}】`;
      // 数量1改变
      QuantityToQuantity2Processor.execute(updateRetailDetail);
    }
    if ("Quantity2" === updateProp.name) {
      // 数量1改变
      updateRetailDetail.Quantity2 = updateProp.newData;
      desc = `修改存货【${updateRetailDetail.Inventory.Name}】数量2为【${updateRetailDetail.Quantity2}】`;
      Quantity2ToQuantityProcessor.execute(updateRetailDetail);
    }
    if ("ProductionDate" === updateProp.name) {
      // 生产日期改变
      desc = `修改存货【${updateRetailDetail.Inventory.Name}】生产日期为【${updateProp.newData.toLocaleDateString()}】`;
      await CalculateExpiryDateProcessor.execute(updateRetailDetail, updateProp.newData);
      // CalculateExpiryDateProcessor.execute(updateRetailDetail, updateProp.newData);
    }
    if ("ExpiryDate" === updateProp.name) {
      // 失效日期改变
      desc = `修改存货【${updateRetailDetail.Inventory.Name}】失效日期为【${updateProp.newData.toLocaleDateString()}】`;
      await CalculateProductionDateProcessor.execute(updateRetailDetail, updateProp.newData);
      // CalculateProductionDateProcessor.execute(updateRetailDetail, updateProp.newData);
    }

    //tuzh 存货相关修改暂时关闭，否则日志量会很大
    //AddLogProcessor.execute("修改存货", this.data.Code, desc);
  }

  //修改备注
  @operationLog('updateSingleMemo', '商品({0})修改备注信息为{1}', ['1-Inventory.Name', '0'])
  async updateSingleMemo(SingleMemo, targetIndex) {
    runInAction(() => {
      this.data.RetailDetails[targetIndex].Memo = SingleMemo;
      console.log('进入备注业务处理逻辑');
    });
  }

  //修改整单备注
  // @operationLog('updateMemo', '修改整单备注信息为{0}', ['0'])
  async updateWholeMemo(WholeMemo) {
    runInAction(() => {
      this.data.Memo = WholeMemo
    })
  }

  //修改存货序列号
  async updateSerialNumber(SerialNumber, SerialNumberMemo, targetIndex) {
    runInAction(() => {
      let Inventory = this.data.RetailDetails[targetIndex];
      if (Inventory) {
        Inventory.SerialNumber = SerialNumber;
        Inventory.SerialNumberMemo = SerialNumberMemo;
      }
    })
  }

  async deleteBodyItem(paramIn) {
    let {
      index
    } = paramIn;
    runInAction(() => {
      console.log('进入明细删除业务处理逻辑->paramIn=====', paramIn);
      let desc = `删除明细行【${index}】,明细行存货【${this.data.RetailDetails[index].Inventory.Name}】的数据`;
      RowDeleteProcessorBlock.execute(this.data, index);
      AddLogProcessor.execute("删除明细行", this.data.Code, desc);
    });
  }

  async updateBodyItem(updateRetailDetail, {
    index,
    updateProp
  }) {
    let funName = `update${updateProp.name}`;
    if (this[funName]) {
      this[funName](updateRetailDetail, {
        index,
        updateProp
      });
    }
    else {
      console.warn('方法：[' + funName + ']不存在！');
    }
  }


  //修改数量
  async updateQuantity(updateRetailDetail, {
    index,
    updateProp
  }) {
    console.log('进入数量编辑逻辑->paramIn=====', {
      index,
      updateProp
    });


    let desc = `修改存货【${this.data.RetailDetails[index].Inventory.Name}】数量从【${this.data.RetailDetails[index].Quantity}】为【${updateProp.newData}】`;
    QuantityChangeProcessorBlock.execute(this.data, this.data.RetailDetails[index], updateProp.newData, {});

    // tuzh 原单退货 退货数量等于最大可退数量，需要调用退货金额算法，减少退货误差
    if (this.isOriginalReturnDetail(index)) {
      ReturnTaxAmountProcessBlock.execute(this.data, this.data.RetailDetails[index]);
    }
    //tuzh 存货相关修改暂时关闭，否则日志量会很大
    //AddLogProcessor.execute("修改数量", this.data.Code, desc);
  }

  /**
   * 修改明细行金额
   */
  @operationLog('updateSingleAmount', '商品({0})价格由{1}改为{2}', ['1-Inventory.Name', '1-TaxAmount', '0'])
  async updateSingleAmount(SingleAmount, targetIndex) {
    console.log('修改明细行金额');
    $T.debugger();
    TaxAmountChangeProcessorBlock.execute(this.data, this.data.RetailDetails[targetIndex], SingleAmount);
  }

  /**
   * 修改数量2
   * @param {*} Quantity2
   * @param {*} targetIndex
   */
  @operationLog('updateQuantity2', '商品({0})数量2由{1}改为{2}', ['1-Inventory.Name', '1-Quantity2', '0'])
  async updateQuantity2(Quantity2, targetIndex) {
    Quantity2ChangeProcessorBlock.execute(this.data, this.data.RetailDetails[targetIndex], Quantity2, {});
  }

  /**
   * 修改计量单位2
   * @param {*} updateRetailDetail
   * @param {*} param1
   */
  async updateUnit(updateRetailDetail, {
    index,
    updateProp
  }) {
    await UnitProcessorBlock.execute(this.data, index, updateProp.newData, "Unit1");
  }


  //修改含税单价 即单品改价
  async updateTaxPrice(updateRetailDetail, {
    index,
    updateProp
  }) {
    console.log('进入含税单价逻辑->paramIn=====', {
      index,
      updateProp
    });
    $T.debugger();

    // let oldData = _cloneDeep(toJS(this.data));
    // 含税单价改变
    let desc = `修改存货【${this.data.RetailDetails[index].Inventory.Name}】含税单价从【${this.data.RetailDetails[index].TaxPrice}】为【${updateProp.newData}】`;
    TaxPriceChangeProcessorBlock.execute(this.data, this.data.RetailDetails[index], updateProp.newData);

    AddLogProcessor.execute("修改含税单价", this.data.Code, desc);
    // // 获取弹出框的相关信息
    // let popupMethod = this.getPopupMethodInfomation();

    // let result = await ControlMinPriceProcessorBlock.execute(oldData, oldData.RetailDetails[index], true, false, popupMethod);
    // if (result) {
    //   runInAction(() => {
    //     Object.assign(this.data, oldData);
    //     // Object.assign(this.data.RetailDetails[index], oldData.RetailDetails[index]);
    //     console.log(this.data.RetailDetails[index]);
    //   });

    // }
  }

  @operationLog('updateVoucherDate', '修改单据日期为{0}')
  async updateVoucherDate(voucherDate) {
    if (this.isOriginalReturn() && new Date(this.refundRetail.VoucherDate).getDate() > voucherDate.getDate()) {
      Message.warn("原单退货不支持修改单据日期早于原单日期");
      return;
    }
    //进入日期修改逻辑
    await VoucherDateProcessor.execute(this.data, voucherDate);
  }

  //修改导购员
  @operationLog('updateGuide', '修改导购员ID为{0}')
  async updateGuide(guide) {
    PersonProcessBlock.execute(this.data, null, { "person": guide, "choice": "all" });
  }

  //修改单行导购员
  @operationLog('updateSingleGuide', '商品({0})修改导购员ID为{1}', ['1-Inventory.Name', '0'])
  async updateSingleGuide(guide, targetIndex) {
    PersonProcessBlock.execute(this.data, this.data.RetailDetails[targetIndex], { "person": guide, "choice": "detail" });
  }

  /* 加载voucherbody 数据(merge datamodel) */
  async loadVoucherBody(dataModel) {
    await runInAction(() => {
      this.data.merge(dataModel);
    })
    return true;
  }

  /* tuzh 原单退货相关逻辑处理 ----begian*/

  /* 加载voucherbody-原单退货 */
  async loadRefundVoucherBody(dataModel) {
    $T.debugger();
    console.log("initReturnInventory开始");
    await this.initReturnInventory();
    console.log("initReturnInventory结束");
    await runInAction(() => {
      let sourceDate = dataModel.VoucherDate;
      console.log("OriginalReturnProcessBlock开始");
      //tuzha 处理原单退货的零售单信息
      OriginalReturnProcessBlock.execute(this.data, dataModel);
      console.log("OriginalReturnProcessBlock结束");
      // 创建一个原单快照，校验数量等信息需要
      this.refundRetail = _cloneDeep(toJS(this.data));
      this.refundRetail.VoucherDate = sourceDate;
      JSON.setCellValue(this.data, "IsOriginalReturn", true);
      // 原单退货数据
      JSON.setCellValue(this.data, "refundRetail", this.refundRetail);
      // //原单退货选择完存货后自动触发状态控制
      // this.refundVoucherControl(0);

    })

    return true;
  }
  //获取退货明细行数据
  getRefundDetail(index) {
    if (!this.isOriginalReturnDetail(index) || !this.refundRetail) {
      return null;
    }
    return this.refundRetail.RetailDetails.find(it => it.ReturnSourceDetailId == this.data.RetailDetails[index].ReturnSourceDetailId);
  }

  //校验原单退货数量
  @action checkRefundQuantity(index, quantity) {
    $T.debugger();
    if (!this.isOriginalReturnDetail(index)) {
      return true;
    }
    let detailDto = getRefundDetail(index);
    if (!detailDto)//找不到明细，则认为是换货，原单有代金券结算时，不允许录入正数存货
    {
      if (quantity < 0) {
        this.data.RetailDetails[index].Quantity = 0;
        Message.warn("原单退货换货数量不能为负数");
        return false;
      }
      return true;
    }
    if (quantity < detailDto.Quantity) {
      this.data.RetailDetails[index].Quantity = detailDto.Quantity;
      Message.warn("原单退货数量不能大于最大可退数量");
      return false;
    }
    if (quantity >= 0) {
      this.data.RetailDetails[index].Quantity = -1;
      Message.warn("原单退货数量不能为正数");
      return false;
    }
    return true;
  }

  /* tuzha  是否原单退货 */
  isOriginalReturn() {
    return JSON.getCellValue(this.data, "IsOriginalReturn");
  }

  isOriginalReturnDetail(index) {
    if (index <= -1) {
      return false;
    }
    if (JSON.getCellValue(this.data, "IsOriginalReturn") == true && this.data.RetailDetails[index].ReturnSourceDetailId) {
      return true;
    }
    return false;
  }

  //处理原单退货的结算方式
  @action async OriginalReturnPayment() {
    await OriginalReturnPaymentProcessBlock.execute(this.data)
  }

  /* tuzh 原单退货相关逻辑处理 ----end*/


  /* 解单数据 */
  async loadWithoutVoucherBody(dataModel) {
    await runInAction(() => {
      delete dataModel.Code;
      delete dataModel.VoucherDate;
      // 删除原单收银员信息
      delete dataModel.UserCode
      delete dataModel.UserId
      delete dataModel.UserName
      delete dataModel.DailyCode   // 日结
      // delete dataModel.IdDailyVoucher   // 日结
      delete dataModel.ShiftCode    //交班
      delete dataModel.IdShiftVoucher    //交班
      dataModel.Shift && delete dataModel.Shift.Id
      // const { Member , RetailDetails} = dataModel;
      // const newDataModel = { Member , RetailDetails };
      this.data.merge(dataModel);
    })
    //原单退货选择完存货后自动触发状态控制
    this.refundVoucherControl(0);
    return true;
  }
  /**
   * 单据提交时校验
   */
  @action async onValidate() {
    console.log("onValidate开始执行");
    // 获取弹出框的相关信息
    let popupMethod = this.getPopupMethodInfomation();
    // 计算时校验
    let result = await SettleValidateProcessorBlock.execute(this.data, popupMethod);
    console.log("onValidate执行完成");
    return result;
  }

  /**
   *  权限校验
   */
  @action async  authorityValidate() {
    console.log("authorityValidate开始执行");
    let popupMethod = this.getPopupMethodInfomation();
    // 计算时校验
    let result = await AuthorityValidateProcessorBlock.execute(this.data, popupMethod);
    console.log("authorityValidate执行完成");
    return result;
  }



  /**
   * 扣次单据提交时校验
   */
  @action async onValidateForMemberDeduction() {
    console.log("onValidateForMemberDeduction开始执行");
    let result=true;
    if(stores&&stores.memberDeductionStore&&stores.memberDeductionStore.data&&stores.memberDeductionStore.data.PackageInfo.length){
      // 获取弹出框的相关信息
      let popupMethod = this.getPopupMethodInfomation();
      // 扣次前校验
      result =await DeductionValidateProcessorBlock.execute(stores.memberDeductionStore.data, popupMethod);
    } else {
      console.log("stores.memberDeductionStore.data无数据");
    }
    console.log("onValidateForMemberDeduction执行完成");
    return result;
  }

  /**
    * 打印零售单
    */
  async printRetail(id, dto, openCashBox) {
    $T.debugger();
    await printDispatch(DoNameList.DO_PRINT,id,{
      dto,
      openCashBox
    })
  }

  /**
    * 打印零售单
    */
  async printMtRetail({ID}) {
    $T.debugger();
    await printDispatch(DoNameList.DO_MT_RETAIL,ID)
  }

  /**
   *只打印小票
   *
   * @param {*} id
   * @memberof RetailOrderController
   */
  async onlyPrintRetail({ id }) {
    $T.debugger();
    // 获取弹出框的相关信息
    await printDispatch(DoNameList.DO_ONLY_PRINT,id)
  }

  /**
    * 打印零售单草稿
    */
  async printDraftRetail(dto) {
    $T.debugger();
    // 获取弹出框的相关信息
    await RetailPrintProcessBlock.execute(null, dto.dataModel,false, true);
  }

  /**
   *判断是否有功能权限
   *
   * @param {*} operationName
   * @returns
   * @memberof RetailOrderController
   */
  isHasAuthProcess(operationName) {
    return AuthProcess.execute(operationName)
  }

  /**
   *校验操作按钮
   *
   * @param {*} memberDto
   * @param {*} operationName
   * @returns
   * @memberof RetailOrderController
   */
  ValidateOperationName({ memberDto, operationName }) {
    if (operationName == 'MemberStorage') {
      let message = CheckMemberStorageProcessorBlock.execute(memberDto);
      if (!String.isNullOrEmpty(message)) {
        Message.warn(message);
        return false;
      }
    }
    if (operationName == 'ProjectStorageNew'||operationName == 'ProjectStorageCost') {
      let message = CheckMemberProjectStorageProcessorBlock.execute(memberDto);
      if (!String.isNullOrEmpty(message)) {
        Message.warn(message);
        return false;
      }
    }

    if (operationName == 'ModifyPassword' || operationName === 'PosResetPwd') {
      return CheckUpdateMemberPasswordProcessorBlock.execute(memberDto);
    }
    return true;
  }

  /**
   *交班单打印
   *
   * @param {*} {id} 交班单ID
   * @memberof RetailOrderController
   */
  async shiftVoucherPrint({ id }) {
    $T.debugger();
    // if (!id) {
    //   id = PosInitData('IdShiftVoucher');
    // }
    let dto = {};
    dto.Idstore = PosInitData('storeID');
    dto.POSCode = PosInitData('posCode');
    await ShiftVoucherPrintProcessBlock.execute(id, dto);
  }
  /**
   *日结单打印
   *
   * @param {*} {id} 交班单ID
   * @memberof RetailOrderController
   */
  async dailyVoucherPrint({ id }) {
    $T.debugger();
    // if (!id) {
    //   id = PosInitData('IdShiftVoucher');
    // }
    let dto = {};
    dto.Idstore = PosInitData('storeID');
    dto.POSCode = PosInitData('posCode');
    await DailyVoucherPrintProcessBlock.execute(id, dto);
  }
  /**
   *手工弹钱箱
   *
   * @memberof RetailOrderController
   */
  openCashBoxByHand() {
    let popupMethod = this.getPopupMethodInfomation();
    OpenCashBoxProcessBlock.execute(this.data, true, popupMethod);
  }


  // --------------------------------促销相关处理开始 by tuzha ----------------------------------

  executePromotions = [];
  // 2、零售单结算时，判断单品返现、组合满返、组合满赠、单品满赠、整单返现、整单满单品优惠和整单满赠。
  @action async startPromotions() {
    // FOR TEST
    // 创建一个促销前的数据快照，要是执行过促销后再修改需要回滚快照
    this.promotionSnapshot = this.data.toJS();
    //tuzha 如果是退货或者自提，不执行结算前促销规则
    if (this.data.IdbusiType == busiTypeID.Code_82 || this.data.DistributionMode.Id == DistributionMode.Code_02) {
      return false;
    }

    // 如果只有一个方案符合，则自动执行。如果有多个方案符合，则弹出所有符合方案供用户选择，用户可选择一个执行。
    this.promotionsData = await PromotionApi.getAllRetailPromotions(this.data.cut());
    //如果后台执行了单品返现
    if (this.promotionsData.IsRunSingleCashBack) {
      runInAction(() => {
        SelfRunPromotionProcessBlock.execute(this.data, this.promotionsData.RetailDTO);
      });

    }
    //没有促销的情况
    if (this.promotionsData.PromotionReturns.length === 0) {
      return false;
    }
    // 只有一个促销的情况，自动执行
    if (this.promotionsData.PromotionReturns.length === 1) {
      //如果是这个促销类型是赠品的话，则还是需要弹出执行
      if (this.promotionsData.PromotionReturns[0].PromotionGifts && this.promotionsData.PromotionReturns[0].PromotionGifts.length > 0) {
        return true;
      }
      //如果是整单单品优惠的话，也还是需要弹出执行
      if (this.promotionsData.PromotionReturns[0].PromotionDiscounts && this.promotionsData.PromotionReturns[0].PromotionDiscounts.length > 0) {
        return true;
      }
      runInAction(() => {
        SettlePromotionProcessBlock.execute(this.data, this.promotionsData.PromotionReturns[0], this.promotionsData.PromotionReturns)
      });
      return false;
    }
    this.executePromotions = [];
    //返回促销后的零售单信息
    this.returnPromotionSnapshot = this.data.toJS();
    this.PromotionReturns = _cloneDeep(toJS(this.promotionsData.PromotionReturns));
    // 返回是否有促销方案
    return true;
  }

  // 计算可用的方案
  async calcNextPromotions() {
    // TODO
    return this.promotionsData.PromotionReturns.filter(it => it.IsEnable);
  }

  // 执行指定的方案
  @action async executePromotion(promotionKey, gifts) {
    const promotiondto = this.promotionsData.PromotionReturns.find(it => it.ID === promotionKey);
    // TODO(执行促销)
    SettlePromotionProcessBlock.execute(this.data, promotiondto, this.promotionsData.PromotionReturns, gifts)

    this.executePromotions.push(promotiondto);
  }

  // 计算当前促销可以提供的赠品或打折商品
  async calcPromotionGifts(promotionKey) {
    const current = this.promotionsData.PromotionReturns.find(it => it.ID === promotionKey);
    // 整单满单品优惠
    if (current.PromotionType == PromotionType.DR_PromotionType_04) {
      return {
        data: current.PromotionDiscounts,
        total: 0
      }
    }
    else //赠品情况
    {
      //如果是成倍赠送，则需要计算赠送的赠品总数量
      current.TotalGiftItem = current.GiftItem;
      if (current.IsMultipleGift && !current.IsCalc) {
        CalcMultGiftItemProcessBlock.execute(current);
      }

      if (!current.GiftItem) {
        return null;
      }

      const giftsdata = [];
      current.PromotionGifts.forEach(item => { 
        item.Batch = null;
        item.ProductionDate = null;
        item.ExpiryDate = null;
        giftsdata.push(item)
      })

      //判断赠品只有一种，且没有自由项和批次的情况下，自动填充数量
      //批号不必录时，促销选赠品时也不控制批号必录 by tuzha 2020-06-01
      let isBatchNumberViladate = PosInitData ('Isbatchnumberviladate');
      if (giftsdata.length == 1&&!giftsdata[0].Inventory.IsSerialNumber) {
        let LimitedGiftQuantity = JSON.getCellValue(giftsdata[0], "LimitedGiftQuantity");
        if (current.ViewInfos.length == 6||isBatchNumberViladate!="1") {
          if (LimitedGiftQuantity && LimitedGiftQuantity > 0) {
            giftsdata[0].Quantity = LimitedGiftQuantity >= current.TotalGiftItem ? current.TotalGiftItem : LimitedGiftQuantity;

          }
          else {
            giftsdata[0].Quantity = current.TotalGiftItem;
          }
        }
        if (LimitedGiftQuantity && LimitedGiftQuantity > 0) {
          current.TotalGiftItem = LimitedGiftQuantity >= current.TotalGiftItem ? current.TotalGiftItem : LimitedGiftQuantity;
        }
      }
      return {
        data: giftsdata,
        total: current.TotalGiftItem || 0
      }
    }
  }

  async calcPromotionColumns(promotionKey) {
    const current = this.promotionsData.PromotionReturns.find(it => it.ID === promotionKey);

    const functionAuth = PosInitData("FunctionAuth")
    let isModifyQuantity = true;
    if (Array.isArray(functionAuth)) {
      isModifyQuantity = functionAuth.includes('UpdateQuantity');
    }

    const quantityField = current.ViewInfos.find((el) => el.key === 'Quantity')
    if (quantityField) quantityField.quick = !!isModifyQuantity;

    return current.ViewInfos;
  }


  //赠品或者整单单品优惠扫码商品
  @action async getInventoryData(promotionKey, code) {

    const promotion = this.promotionsData.PromotionReturns.find(it => it.ID === promotionKey)
    if (!promotion) {
      return null;
    }

    let idmember = '';
    if (this.data.Idmember) {
      idmember = this.data.Idmember;
    }

    let promotionDiscounts = '';

    if (promotion.PromotionType == PromotionType.DR_PromotionType_04) //整单单品优惠
    {
      switch (promotion.PromotionObject) {
        case PromotionObject.DR_PromotionObject_00: //存货类型
          promotion.PromotionDiscounts.forEach(it => {
            promotionDiscounts = promotionDiscounts + "," + it.Idinventory + "_" + it.Idunit
          })
          break;
        case PromotionObject.DR_PromotionObject_01: //存货分类
          promotion.ç.forEach(it => {
            promotionDiscounts = promotionDiscounts + "," + it.Inid;
          })
          break;
        case PromotionObject.DR_PromotionObject_02: //存货品牌
          promotion.PromotionDiscounts.forEach(it => {
            promotionDiscounts = promotionDiscounts + "," + it.CorpBrand.Id;
          })
          break;
      }
    }
    else {
      promotion.PromotionGifts.forEach(detail => {
        promotionDiscounts = promotionDiscounts + "," + detail.Idinventory + "_" + detail.Idunit
      })
    }
    if (promotionDiscounts) {
      promotionDiscounts = promotionDiscounts.substring(1);
    }
    const wholeFullSingleInfo = await PromotionApi.getInventoryData(idmember, this.data.Idstore, code, promotion.PromotionType, promotion.CashBackWay, promotion.PromotionObject, promotionDiscounts);

    return wholeFullSingleInfo;
  }

  //一码多物时调用
  @action async getInventoryInfo(promotionKey, idInventory, barcode,serialNumberId) {
    const promotion = this.promotionsData.PromotionReturns.find(it => it.ID === promotionKey)
    if (!promotion) {
      return null;
    }
    let idmember = "";
    if (this.data.Idmember) {
      idmember = this.data.Idmember
    }
    if(!serialNumberId)
    {
      serialNumberId="";
    }
    if(!barcode)
    {
      barcode="";
    }
    //处理idUnit
    let idUnit = '';
    if (promotion.PromotionType == PromotionType.DR_PromotionType_04) //整单单品优惠
    {
      if (promotion.PromotionObject == PromotionObject.DR_PromotionObject_00) {
        let discountInfo = promotion.PromotionDiscounts.find(it => it.Idinventory == idInventory);
        if (discountInfo) {
          idUnit = discountInfo.Idunit;
        }
      }
    }
    else {
      promotion.PromotionGifts.forEach(detail => {
        if (detail.Idinventory == idInventory) {
          idUnit = detail.Idunit;
        }
      })
    }

    const inventoryInfo = await PromotionApi.getInventoryInfo(idInventory, idmember, this.data.Idstore, barcode, promotion.PromotionType, promotion.CashBackWay, idUnit,serialNumberId);
    // TODO
    return inventoryInfo;
  }

  //整单单品优惠促销 RetailDetailData
  @action checkPromotionPrice(promotionKey, gifts) {
    const promotion = this.promotionsData.PromotionReturns.find(it => it.ID === promotionKey)
    //处理促销价格
    if (!promotion || !gifts) {
      return;
    }
    //非整单单品优惠促销
    if (promotion.PromotionType != PromotionType.DR_PromotionType_04) {
      return;
    }
    PreWholeFullSingleProcessBlock.execute(promotion, gifts);
  }

  @action checkPromotionQuantity(promotionKey, gifts, currentgift) {

    if (currentgift.Quantity == 0) {
      return true;
    }

    // 检查数量规则，要是要过需要直接修改gifgs字段
    const currentPromotion = this.promotionsData.PromotionReturns.find(it => it.ID === promotionKey);
    if ((currentPromotion.PromotionType != PromotionType.DR_PromotionType_05) && (currentPromotion.PromotionType != PromotionType.DR_PromotionType_06) && (currentPromotion.PromotionType != PromotionType.DR_PromotionType_07)) {
      return true;
    }

    //获取除此数据的赠品数量
    let usedQuantity = 0;
    let currentKey = this.getDetailKey(currentgift);
    gifts.forEach(item => {
      let key = this.getDetailKey(item);
      if (key == currentKey || parseInt(item.Quantity) == 0) {
        return
      }
      usedQuantity = usedQuantity + parseInt(item.Quantity);
    })
    let isValid = true;
    //获取当前促销赠品的信息
    let promotionGift = currentPromotion.PromotionGifts.find(c => c.Idinventory == currentgift.Idinventory);
    if (promotionGift) {
      //处理限制信息
      let limitedQuantity = 0;
      //JSON.getCellValue(giftDto,giftFreeItemName);
      let LimitedGiftQuantity = JSON.getCellValue(promotionGift, "LimitedGiftQuantity");
      if (LimitedGiftQuantity && LimitedGiftQuantity > 0) { //有赠品限制
        //计算限制的值
        let usedLimit = 0
        gifts.filter(c => c.Idinventory == currentgift.Idinventory && c != currentgift).forEach(item => {
          usedLimit = usedLimit + parseInt(item.Quantity);
        });
        limitedQuantity = LimitedGiftQuantity - usedLimit;
        limitedQuantity = (currentPromotion.TotalGiftItem - usedQuantity) > limitedQuantity ? limitedQuantity : (currentPromotion.TotalGiftItem - usedQuantity);
      }
      else { //没有赠品限制
        limitedQuantity = (currentPromotion.TotalGiftItem - usedQuantity);
      }
      if (limitedQuantity > 0) {
        if (currentgift.Quantity > limitedQuantity) {
          currentgift.Quantity = limitedQuantity;
          isValid = false;
        }
      }
      else {
        currentgift.Quantity = 0;
        isValid = false;
      }
    }
    return isValid
  }


  // 取消所有执行的方案
  async cancelPromotion(all = false) {

    let desc = '取消了所有促销方案执行！'
    // 恢复促销前数据
    if (all) {
      if (this.promotionSnapshot) {
        console.log("恢复促销前数据-->" + JSON.stringify(this.promotionSnapshot))
        this.data.restore(this.promotionSnapshot);
      }
    }
    else //只是取消执行的促销方案
    {
      desc = `取消了已选择的促销方案执行！`
      if (this.returnPromotionSnapshot) {
        this.data.restore(this.returnPromotionSnapshot);
        this.promotionsData.PromotionReturns = _cloneDeep(toJS(this.PromotionReturns))
      }
    }
    AddLogProcessor.execute("取消促销", this.data.Code, desc);
    this.executePromotions = [];
  }

  // 所有方案选完了点确定后
  async finishPromotion() {

  }

  getDetailKey(detail) {
    let returnKey = "";
    let keyFields =
      "FreeItem0,FreeItem1,FreeItem2,FreeItem3,FreeItem4,FreeItem5,FreeItem6,FreeItem7,FreeItem8,FreeItem9,Idinventory,Idunit,Batch,ProductionDate,ExpiryDate,ReturnSourceDetailId,SerialNumber";

    let keyArrays = keyFields.split(",");
    for (let index = 0; index < keyArrays.length; index++) {
      let value = "";
      if (JSON.getCellValue(detail, keyArrays[index])) {
        value = JSON.getCellValue(detail, keyArrays[index]);
      }
      if (value && (keyArrays[index] == 'ProductionDate' || keyArrays[index] == 'ExpiryDate')) {
        let date = value;
        if (typeof (value) == "string") {
          date = new Date(value);
        }
        value = date.toLocaleDateString();
      }
      returnKey = returnKey + "|" + keyArrays[index] + "=" + value;
    }
    return returnKey;
  }

  //执行自助收银促销
  @action async startSelfPromotions() {
    // 创建一个促销前的数据快照，要是执行过促销后再修改需要回滚快照
    this.promotionSnapshot = this.data.toJS();
    //tuzha 如果是退货或者自提，不执行结算前促销规则
    if (this.data.IdbusiType == busiTypeID.Code_82 || this.data.DistributionMode.Id == DistributionMode.Code_02) {
      return false;
    }
    // 如果只有一个方案符合，则自动执行。如果有多个方案符合，则弹出所有符合方案供用户选择，用户可选择一个执行。
    const returnData = await PromotionApi.selfSettlePromotion(this.data.cut());
    //如果后台执行了促销方案
    if (returnData.IsExecPromotion) {
      runInAction(() => {
        SelfRunPromotionProcessBlock.execute(this.data, JSON.parse(returnData.RetailDTO))
      });
    }
    return true;

  }

  //--------------------------------促销处理相关逻辑结束 by tuzh------------------------------------

  //tuzh 获取代金券、积分抵现、会员储值可用金额
  getAvailableAmount(code) {
    let toatalAmount = 0;
    this.data.RetailDetails.forEach(item => {
      if (code == SettleCode.Storage && item.IsUseStorage) //储值结算
      {
        return;
      }
      if ((code == SettleCode.Coupon || code == SettleCode.Integral) && item.IsUseIntegralAndCash) {
        return;
      }
      toatalAmount = Math.Add(toatalAmount, item.TaxAmount);
    })
    console.log("可用代金券、积分抵现、储值卡结算金额为：" + toatalAmount);
    return toatalAmount;
  }

  /* 校验是否允许称重 */
  checkCanWeighFromBarCode(RetailDetail) {
    return CheckCanWeighFromBarCodeBlock.execute(RetailDetail);
  }
}